import {createApi} from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const firmantesApi = createApi({
    reducerPath: "firmantesApi",
    baseQuery: customFetchBase,
    tagTypes: ["Firmantes"],
    endpoints: () => ({})
});
